export default () => ({ 
    page: document.location.pathname,
    menu: false, 
    mobilenav: false, 
    scrollNumber: 0,
    navHeight: 0,
    // Team Modal Data
    open: false, 
    img: '',
    name: '',
    role: '',
    bio: '',
    email: '',
    mailto: '',
    linkedin: '',
    get modalClass() {
      return this.open ? 'open' : '';
    },
    openModal() {
      console.log('openModal');
      this.open = true;
      // document.getElementById('swup').classList.toggle('dim');
    },
    closeModal() {
      console.log('closeModal');
      this.open = false;
    },
    // startPoint: $refs.start.offsetTop,
    // stop: $refs.parallax.getClientBoundingRect.height,
    mobile: window.matchMedia('only screen and (max-width: 760px)').matches,
    init() {
        this.navHeight = document.querySelector('.header').getBoundingClientRect().height
        window.addEventListener('navigated', event => {
            // Fixes an issue where navigation via browser back / forward would not set
            // this.page, thus making the navbar lose "sync" with the actual current location
            this.page = document.location.pathname
            
        })
    },
    toggleMobileNav() {
      if(!this.$el.classList.contains('burger')) {
        window.scrollTo(0,0);
      }
      this.mobilenav = ! this.mobilenav;
      
      if(this.mobilenav == true) {
        document.body.classList.add('lock');
      } else {
        document.body.classList.remove('lock');
      }
    },
    closeMobileNav() {
      this.mobilenav = false;
      document.body.classList.remove('lock');
    },
    onScroll() {
        this.scrollNumber = window.pageYOffset;
    },
    onResize() {
        this.mobile = window.matchMedia('only screen and (max-width: 760px)').matches
    },
    clickLogo(e) {
        this.page = '/'
    },
    get bodyClass() {
        return this.mobilenav ? 'lock' : ''
    },
    get headerClass() {
        return {
            'scrolled': this.scrollNumber > 0,
            'home': this.page === '/',
            'acc': this.page === '/accelerator/roads-of-the-future' || this.page === '/accelerator/water-solutions' || this.page === '/accelerator/sustainable-building-materials',
            'dark': this.page === '/contact' || this.page === '/upload',
            'mobilemenu': this.mobilenav === true
        }
    },
    get logoClass() {
        return this.mobilenav ? 'hide' : ''
    },
    get notMobile() {
        return !this.mobile
    },
    get burgerClass() {
        return this.mobilenav  ? 'active' : ''
    },
    get overlayClass() {
        return this.mobilenav ? 'active' : ''
    }
})

export const mainNavLink = () => ({
    get class() {
        if (this.page === this.$el.dataset.page) {
            return 'active'
        } else {
            return ''
        }
    },
    homeFromMobile() {
        this.toggleMobileNav()
        this.page = ''
    },
    clickNavLink(e) {
        this.page = e.target.dataset.page
    },
    clickNavLinkMobile(e) {
        this.page = e.target.dataset.page
        this.toggleMobileNav()
    }
});









var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);